import React, { FC, SVGProps } from 'react';

export const KeepMoreMoney: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="88" height="88" rx="44" fill="#BAE1D1" />
    <circle
      cx="58.5061"
      cy="36.0818"
      r="4.86154"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="40.686"
      cy="27.6362"
      r="6.88718"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9036 40.9431H19.6113V62.82H26.9036V40.9431Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9023 59.725C32.1167 63.2154 38.3872 65.251 45.1331 65.251C54.5365 65.251 63.0161 61.2958 68.9991 54.9582C67.2522 52.369 64.2915 50.6663 60.9331 50.6663H52.1159M53.6408 55.5279C53.6408 53.7203 53.0771 52.0444 52.1159 50.6663M52.1159 50.6663C50.5785 48.4623 48.0242 47.0202 45.1331 47.0202H38.9802C36.4092 44.7509 33.0319 43.374 29.3331 43.374H26.9023"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.6423 55.5278H36.627"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
